import { Component,  OnInit, ViewChild } from '@angular/core';
// import { GetviewBO, ColumnChangeBO, generate270, reutrn270, EDI271ClientBO } from '../../models/vieweligibility271.model';
import { GlobalComponent } from 'src/app/global/global.component';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { FilterSettingsModel, IFilter, GridComponent, PageSettingsModel, DataStateChangeEventArgs, QueryCellInfoEventArgs, SelectionSettingsModel, GridModule, ColumnChooserService, SortService, FilterService, ResizeService, PageService } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Output, EventEmitter } from '@angular/core';


import { takeUntil } from 'rxjs/operators';
// import { CommonApiService } from '@services/commonapiservice';
// import { Eligibility271Service } from '@services/vieweligibility271.service';
import { CommonModule } from '@angular/common';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ColumnChangeBO, EDI271BO, EDI271ClientBO, generate270, Getview270BO, reutrn270 } from '../eligibility-logs/eligibility-logs-model';
import { columnWidth } from '../employee/employee.model';
import { Eligibility271Service } from 'src/app/service/vieweligibility271.service';
import { CommonApiService } from 'src/app/service/commonapiservice';
import { Getview271BO } from '../eligibility270/eligibility270.model';
@Component({
  selector: 'app-vieweligibility271',
  templateUrl: './vieweligibility271.component.html',
  styleUrls: ['./vieweligibility271.component.scss'],
 
})
export class Vieweligibility271Component implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  ColumnArray_bachview: ColumnChangeBO[]
  initialPage: PageSettingsModel;
  filterOptions: FilterSettingsModel;
  filter: IFilter;
  arraycol: any = [];
  clientlist: any = [];
  companyList: any;
  generate270: generate270 = new generate270;
  payorList: any = [];
  created270: reutrn270 = new reutrn270;
  groupList: any = [];
  clearingHouseList: any = [];
  viewFiles: boolean = false;
  @ViewChild('pdflist') pdflist;
  today: Date = new Date();
  @Output() close271 = new EventEmitter();
  lasted: any = [];
  edi271list: EDI271BO[] = [];
  viewFiles271: boolean = false;
  public selectionOptions: SelectionSettingsModel;
  ColumnArray: columnWidth[];
  id: number = 0;
  dataviewList271: any = [];
  selectAllActiveValue: boolean = false;
  selectAll: boolean;
  selectAllActive: boolean;
  singledata: any = [];
  multipledata: any = [];
  selectAllValue: boolean = false;
  selectsingleValue: boolean = false;
  selectedIds: any = [];
  validClientList: EDI271ClientBO[];
  edi271ClientList: EDI271ClientBO[];
  result4: any = [];
  SelectAllIdList: any = [];
  SelectAllActiveIdList: any = [];
  @ViewChild("gridview271") public gridview271: GridComponent;
  view271: boolean = true;
  public checkparams;
  public filterSettings: object;
  public formatOptions: object;
  public datavieweb271: Observable<DataStateChangeEventArgs>;
  getview271clients: Getview271BO = new Getview271BO();
  constructor(  public CommonAPI: CommonApiService, public global: GlobalComponent,public gethttp: Eligibility271Service, public toastrService: ToastrService, public http: HttpClient) {
    this.datavieweb271 = this.gethttp;
  }
  ngOnInit(): void {
   // let pag = JSON.parse(this.global?.globalColumn?.column)[0]?.Eligibility271?.Pagesize!=null && JSON.parse(this.global.globalColumn?.column)[0]?.Eligibility271?.Pagesize!=undefined &&JSON.parse(this.global.globalColumn?.column)[0]?.Eligibility271?.Pagesize!=''?JSON.parse(this.global.globalColumn.column)[0]?.Eligibility271?.Pagesize:100;
    this.getview271clients.pageitem=100;
    this.getGroupList();
    this.getClearingHouseList();
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.filterSettings = {
      type: 'Menu',
    };
    this.selectionOptions = {
      checkboxOnly: true
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.view271filedata();
    this.checkparams =
    {
      checked: false
    }
  }
  Refreshview271() {
    let pageItem = this.getview271clients.pageitem;
    this.getview271clients = new Getview271BO();
    this.getview271clients.pageitem = pageItem;
    this.singledata = [];
    this.multipledata = [];
    this.selectsingleValue = false;
    this.selectAllValue = false;
    this.view271filedata();
    this.clientlist = [];
    this.gridview271.clearFiltering();
    this.gridview271.clearSorting();
  }
  getGroupList() {
    let param = new URLSearchParams();
    param.append("ListCode", "PAYER");
    param.append("userId", this.global.userID);
    let url = "api/LOV/getLovDropDown?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(param,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: string, Value: string }]) => {
      this.groupList = data;
      
      this.generate270.groupId = this.groupList?.filter(s => s.lovValue == "MA")[0]?.id;
      this.getpayorList();
    })
  }
  creategenerate270() {
    this.generate270 = new generate270();
    this.generate270.groupId = this.groupList?.filter(s => s.Value == "MA")[0]?.Key;
  }
  getCompanyList() {
    this.generate270.companyId = "00000000-0000-0000-0000-000000000000";
    let myparams = new URLSearchParams();
    if (this.generate270.groupId == null || this.generate270.groupId == undefined || this.generate270.groupId == "00000000-0000-0000-0000-000000000000" ||
      this.generate270.payorId == null || this.generate270.payorId == undefined || this.generate270.payorId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    myparams.append("GroupId", this.generate270.groupId.toString())
    myparams.append("PayorId", this.generate270.payorId.toString());
    let url = "api/Payer/getGroupCompanyBatch?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: number, Value: string }]) => {
      this.companyList = data;
    },
      )
  }
  getClearingHouseList() {
    let url = "api/ClearingHouse/getCommonClearingHouselist?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("",url).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: number, Value: string }]) => {
      this.clearingHouseList = data;
      this.clearingHouseList?.forEach(element => {
        element.Key = element.Key;
      })
    },
      )
  }
  public onActionCompleteview271Clients(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridview271.columns?.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].BatchDetail.ShowColumns?.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].BatchDetail.HideColumns?.forEach(old => {
            hidearr?.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].BatchDetail.ShowColumns.length != count1 || this.arraycol[0].BatchDetail.HideColumns.length != count) {
            this.arraycol[0].BatchDetail.ShowColumns = showarr;
            this.arraycol[0].BatchDetail.HideColumns = hidearr;
          }
        }
      }
    }
    this.getview271clients.currentpageno = this.gridview271.pagerModule.pagerObj.currentPage;
    this.getview271clients.pageitem = this.gridview271.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.getview271clients.type = args.columnType;
    }
  }
  view271filedata() {
    let val = 0;
    this.gethttp.outputValues(this.getview271clients);
    this.datavieweb271.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.dataviewList271 = data?.result;
      val++;
      if (data != null && data != undefined && val == 1) {
        //this.getColumnwidth();
      }
      if (data != null && data.result.length > 15) {
        this.gridview271.height = '500';
      }
      else {
        this.gridview271.height = 'auto';
      }
      this.SelectAllIdList = data.clients;
      this.validClientList = data.validclients;
      this.edi271ClientList = data.result;
      this.selectedIds = [];
      if (this.selectAllValue) {
        this.edi271ClientList?.forEach((element, index) => {
          if (element.medicaid != null && element.medicaid != "") {
            this.selectedIds.push(index);
          }
        });
        setTimeout(() => {
          this.gridview271.selectionModule.selectRows(this.selectedIds);
        }, 1000);
      }
      if (this.selectsingleValue) {
        this.singledata?.forEach(sel => {
          this.edi271ClientList?.forEach((element, index) => {
            if (sel == element.clientPkId)
              this.selectedIds.push(index);
          });
        });
        setTimeout(() => {
          this.gridview271.selectionModule?.selectRows(this.selectedIds);
        }, 1000);
      }
    });
  }
  public dataStateChange271Clients(state): void {
    let type = (state.action.requestType).toString();
    if (type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getview271clients.orderColumn = state.sorted[0].name;
        this.getview271clients.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
      if (this.getview271clients.type == "number") {
        this.getview271clients.value = state.action.currentFilterObject.value.toString();
        this.getview271clients.field = state.action.currentFilterObject.field;
      }
      if (this.getview271clients.type == "date") {
        this.getview271clients.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
        this.getview271clients.field = state.action.currentFilterObject.field;
      }
      else {
        this.getview271clients.value = state.action.currentFilterObject.value;
        this.getview271clients.field = state.action.currentFilterObject.field;
      }
      this.getview271clients.matchCase = state.action.currentFilterObject.matchCase;
      this.getview271clients.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (type == "filtering" && state.action.action == "clearFilter") {
        this.getview271clients.field = "ClientName";
        this.getview271clients.matchCase = false;
        this.getview271clients.operator = "contains";
        this.getview271clients.value = "";
        this.getview271clients.type = "string"
      }
    }
    this.view271filedata();
    if (type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Eligibility271.Pagesize != state.take) {
          this.arraycol[0].Eligibility271.Pagesize = state.take
          this.SaveColumnwidth();
        }
      }
    }
  }
  SelectingClients(args) {
    if (args.checked && args.target.classList.contains('e-checkselectall')) {
      this.selectAllValue = true;
      this.clientlist = [];
      this.clientlist = this.SelectAllIdList;
    }
    else if (args.target.classList.contains('e-checkselect')) {
      this.selectAllValue = false;
      let result = this.gridview271.getRowInfo(args.target)
      let count = 0;
      let data: any = [];
      data = result.rowData;
      if (args.checked) {
        this.clientlist.push(data.clientPkId);
        this.clientlist.forEach(element => {
          if (!element.isCreateBatch) {
            count++;
          }
        });
        this.selectAll = count > 0 ? false : true;
      }
      else {
        this.selectAll = false;
        const index: number = this.clientlist.indexOf(data.clientPkId);
        if (index !== -1) {
          this.clientlist.splice(index, 1);
        }
      }
    }
    else {
      this.clientlist = [];
      this.selectAllValue = false;
    }
  }
  selectClients(args: any): void {
    var customselect = [];
    if (args.checked && args.target.classList.contains('e-checkselectall')) {
      this.selectsingleValue = false;
      this.selectAllValue = true;
      this.singledata = [];
      this.multipledata = this.validClientList;
      if (this.multipledata.length == 0) {
        this.selectAllValue = false;
        this.toastrService.error('270 can only be generated to clients with medicaid number !!!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
      for (var i = 0; i < args.selectedRowIndexes.length; i++) {
        var row = this.gridview271.getRowByIndex(args.selectedRowIndexes[i]);
        if (!row.querySelector('.disablecheckbox')) {
          customselect.push(args.selectedRowIndexes[i])
        }
      }
      this.gridview271.selectRows(customselect)
    }
    else if (args.checked == false && args.target.classList.contains('e-checkselectall')) {
      this.multipledata = [];
      this.selectsingleValue = false;
      this.selectAllValue = false;
    }
    else {
      this.selectsingleValue = true;
      this.selectAllValue = false;
      if (this.multipledata.length > 0) {
        this.singledata = []
        this.singledata = this.multipledata;
        this.multipledata = [];
      }
      let result = this.gridview271.getRowInfo(args.target)
      this.result4 = result.rowData;
      if (args.checked) {
        this.edi271ClientList.forEach(element => {
          if (element.clientPkId == this.result4.clientPkId && element.medicaid != '' && element.medicaid != null) {
            this.singledata.push(element.clientPkId);
          }
        });
      }
      else {
        for (let data of this.singledata) {
          if (this.result4 != undefined && this.result4.clientPkId == data) {
            this.singledata.splice(this.singledata.indexOf(data), 1);
            break;
          }
        }
      }
    }
    //#region Assigning clientlist to send
    if (this.selectAllValue && this.multipledata.length > 0) {
      this.clientlist = this.multipledata;
    }
    else if (this.selectsingleValue && this.singledata.length > 0) {
      this.clientlist = this.singledata;
    }
    else {
      this.clientlist = [];
    }
    //#endregion
  }
  // ..........................checkboxoptions...........................................................................
  CheckboxforViewEligibility(args: any): void {
    var customselect = [];
    this.multipledata = [];
    this.clientlist = [];
    if (args.checked && args.target.classList.contains('e-checkselectall')) {
      this.selectAllValue = true;
      this.multipledata = this.validClientList;
      var row1: any = this.gridview271.getSelectedRecords();
      for (var i = 0; i < args.selectedRowIndexes.length; i++) {
        var row = this.gridview271.getRowByIndex(args.selectedRowIndexes[i]);
        if (!row.querySelector('.disablecheckbox')) {
          customselect.push(args.selectedRowIndexes[i])
        }
      }
      this.gridview271.selectRows(customselect)
      this.clientlist = this.multipledata;
    }
    else {
      this.selectAllValue = false;
      let val = args.selectedRowIndexes;
      if (val.length > 0) {
        var row1: any = this.gridview271.getSelectedRecords();
        this.clientlist = row1.filter(t => t.medicaid != undefined && t.medicaid != null && t.medicaid != '').map(r => r.clientPkId);
      }
      else {
        this.clientlist = [];
      }
      for (var i = 0; i < args.selectedRowIndexes.length; i++) {
        var row = this.gridview271.getRowByIndex(args.selectedRowIndexes[i]);
        if (!row.querySelector('.disablecheckbox')) {
          customselect.push(args.selectedRowIndexes[i])
        }
      }
      this.gridview271.selectRows(customselect);
    }
  }
  getpayorList() {
    this.generate270.payorId = "00000000-0000-0000-0000-000000000000";
    this.generate270.clearingHouseId = "00000000-0000-0000-0000-000000000000";
    let param = new URLSearchParams();
    let GroupId: string = (this.generate270.groupId != null && this.generate270.groupId != undefined) ? this.generate270.groupId : "00000000-0000-0000-0000-000000000000"
    param.append("GroupId", GroupId.toString());
    let url = "api/Payerservice/GetPayerDropdown?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(param,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: string, Value: string }]) => {
      this.payorList = data;
      // this.payorList?.forEach(element => {
      //   element.Key = element.Key
      // })
      console.log(this.payorList);
      let val = this.payorList?.filter(s => s.Value == "MA")[0];
      this.generate270.payorId = val.length > 0 ? val.Key : 0;
    })
  }
  generate270file() {
    let myparams = {
      "clearinghouse": this.generate270.clearingHouseId.toString(),
      "payer": this.generate270.payorId.toString(),
      "company": this.generate270.companyId.toString(),
      "clients": this.clientlist
    }
    let url = "api/Claims/Save270";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(myparams,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.created270 = data;
      document.getElementById("openModal5").click();
    },
    (err: HttpErrorResponse) => {
        this.toastrService.error(err?.error, 'error')
      }
    );
  }
  download270(data) {
    let myparams = new URLSearchParams();
    myparams.append("filepath", data);
    let url = "api/Claims/download270?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      window.open(data[0]);

    },
    (err: HttpErrorResponse) => {
        this.toastrService.error(err?.error, 'error')
      }
    );
  }
  kendopdfdownloadList() {
    this.pdflist.A4 = true,
      this.pdflist.portrait = true,
      this.pdflist.keepTogether = ".prevent-split",
      this.pdflist.scale = 0.8,
      this.pdflist.saveAs("270Report" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
  }
  viewlasteb(id) {
    let myparams = new URLSearchParams();
    myparams.append("id", id);
    let url="api/Claims/GetClients271Detail?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.edi271list = data;
      this.viewFiles271 = true;
      document.getElementById("openModal7").click();
    },
    (err: HttpErrorResponse) => {
        this.toastrService.error(err?.error, 'error')
      }
    );
  }
  ///////////////////////////////////validate button//////////////////////////////////////////////////////////////
  validatebutton(args: QueryCellInfoEventArgs) {
    if (args.column.field == "view271") {
      if (args.data['lastEligibilityCheck'] == '' || args.data['lastEligibilityCheck'] == null) {
        args.cell.children[0].classList.add('disableedit');
      }
    }
  }
  showColumn() {
    this.gridview271.columnChooserModule.openColumnChooser(200, 50);
  }
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray = this.arraycol[0]?.Eligibility271?.Columns;
    let showcol = this.arraycol[0]?.Eligibility271?.ShowColumns;
    let hidecol = this.arraycol[0]?.Eligibility271?.HideColumns;
    this.gridview271.hideColumns(hidecol);
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    this.gridview271.pageSettings.pageSize = this.arraycol[0].Eligibility271.Pagesize;
    this.ColumnArray.forEach(element => {
      if (element.column == 'Name') {
        const column = this.gridview271.getColumnByField('clientName');
        column.width = element.width;
        this.gridview271.refreshHeader();
      }
      if (element.column == 'Gender') {
        const column1 = this.gridview271.getColumnByField('gender');
        column1.width = element.width;
        this.gridview271.refreshHeader();
      }
      if (element.column == 'DOB') {
        const column1 = this.gridview271.getColumnByField('dob');
        column1.width = element.width;
        this.gridview271.refreshHeader();
      }
      if (element.column == 'Medicaid ID') {
        const column1 = this.gridview271.getColumnByField('clientID');
        column1.width = element.width;
        this.gridview271.refreshHeader();
      }
      if (element.column == 'City') {
        const column1 = this.gridview271.getColumnByField('city');
        column1.width = element.width;
        this.gridview271.refreshHeader();
      }
      if (element.column == 'State') {
        const column1 = this.gridview271.getColumnByField('state');
        column1.width = element.width;
        this.gridview271.refreshHeader();
      }
      if (element.column == 'Zip Code') {
        const column1 = this.gridview271.getColumnByField('zipCode');
        column1.width = element.width;
        this.gridview271.refreshHeader();
      }
      if (element.column == 'Last Eligibility Check') {
        const column1 = this.gridview271.getColumnByField('lastEligibilityCheck');
        column1.width = element.width;
        this.gridview271.refreshHeader();
      }
      else if (element.column == 'Actions') {
        const column2 = this.gridview271.getColumnByUid('action');
        column2.width = element.width;
        this.gridview271.refreshHeader();
      }
    });
  }
  onResize(args) {
    if (this.ColumnArray != null && this.ColumnArray != undefined) {
      const column = this.gridview271.getColumnByField(args.column.field);
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      this.SaveColumnwidth();
    }
  }
  SaveColumnwidth() {
    this.arraycol[0].Eligibility271.Columns = this.ColumnArray;
    this.arraycol[0].Eligibility271.Pagesize = this.gridview271.pageSettings.pageSize;
    this.columnchange.userid = parseInt(this.global.userID);
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id;
    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    let url = "api/ColumnChange/Savewidth?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      //this.getColumnwidth();
    });
  }
  rowDataBound(args) {
    if (args.data['medicaid'] == null || args.data['medicaid'] == "") {
      args.row.getElementsByClassName('e-gridchkbox')[0].classList.add('disablecheckbox');
      args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('disablecheckbox')
    }
  }
  GetEligibilityExportCsv() {
    let url = "api/Claims/GetEligibilityExport";
    this.CommonAPI.saveorUpdateFunctionFileSaver(this.getview271clients,url, "Eligibility271Report.csv");
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
